module.exports = __webpack_public_path__ + "media/images/story/top/ring-132af1e730ae3260d9e8bc31b19f9cc2.png";